import { cva, type VariantProps as CVAVariantProps } from 'class-variance-authority';

/**
 * Re-export VariantProps da class-variance-authority
 */
export type { CVAVariantProps };

/**
 * Utility per creare varianti di componenti con class-variance-authority
 * 
 * Questa è una re-export della funzione cva per mantenere consistenza
 * con gli altri utility della libreria
 */
export { cva };

/**
 * Varianti di colore comuni per i componenti
 * Mappano le varianti ai colori Tailwind
 */
export const colorVariants = {
  primary: 'bg-blue-500 hover:bg-blue-600 text-white border-blue-500',
  secondary: 'bg-indigo-500 hover:bg-indigo-600 text-white border-indigo-500',
  success: 'bg-green-500 hover:bg-green-600 text-white border-green-500',
  error: 'bg-red-500 hover:bg-red-600 text-white border-red-500',
  warning: 'bg-amber-500 hover:bg-amber-600 text-white border-amber-500',
  info: 'bg-cyan-500 hover:bg-cyan-600 text-white border-cyan-500',
  ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 border-transparent',
  link: 'bg-transparent hover:underline text-blue-600 border-transparent',
};

/**
 * Varianti outline (bordi colorati, sfondo trasparente)
 */
export const outlineVariants = {
  primary: 'bg-transparent hover:bg-blue-50 text-blue-600 border-blue-500',
  secondary: 'bg-transparent hover:bg-indigo-50 text-indigo-600 border-indigo-500',
  success: 'bg-transparent hover:bg-green-50 text-green-600 border-green-500',
  error: 'bg-transparent hover:bg-red-50 text-red-600 border-red-500',
  warning: 'bg-transparent hover:bg-amber-50 text-amber-600 border-amber-500',
  info: 'bg-transparent hover:bg-cyan-50 text-cyan-600 border-cyan-500',
  ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 border-gray-300',
  link: 'bg-transparent hover:underline text-blue-600 border-transparent',
};

/**
 * Dimensioni comuni per i componenti
 */
export const sizeVariants = {
  xs: 'text-xs px-2 py-1',
  sm: 'text-sm px-3 py-1.5',
  md: 'text-base px-4 py-2',
  lg: 'text-lg px-6 py-3',
  xl: 'text-xl px-8 py-4',
};

